<template>
  <div>
    <section
      v-for="(badge, idx) in badges"
      :key="idx"
      class="badges-container d-flex flex-wrap justify-content-center align-items-center w-100 p-20"
    >
      <div
        v-if="badge"
        class="badge-item container px-3 d-flex p-1 bg-white shadow-sm flex-column flex-sm-row "
      >
        <img
          v-if="badge.image"
          :src="badge.image"
          fluid
          :class="badge.score == badge.score_requirement ? '' : 'filter-gray'"
          class="badge-image rounded"
        />
        <i v-else class="material-icons cursor h1 m-0 p-0 text-secondary">
          local_police
        </i>
        <div class="badge-info d-flex flex-column justify-content-center h-100">
          <label class="badge-title">{{ badge.name }}</label>
          <small>{{ badge.description }}</small>
          <div class="badge-progress">
            <label class="progress-text">{{ badge.score }}/{{ badge.score_requirement }}</label>
            <b-progress
              :value="calculateBadgeProgress(badge)"
              :max="100"
              variant="warning"
            ></b-progress>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  props: {
    badges: Array,
  },
    computed: {
    calculateBadgeProgress() {
      return (badge) => {
        return (badge.score / badge.score_requirement) * 100;
      };
    },
  },
};
</script>

